import { createAuthClient } from "better-auth/react"
import { phoneNumberClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL,
    plugins: [
        phoneNumberClient()
    ]
})

export const { signIn, signUp, signOut, useSession, phoneNumber, updateUser, getSession, deleteUser, changePassword, sendVerificationEmail } = authClient;